import { types } from "../../types/types";

const initialState = {
  // buscadorPracticas: [],
  practicas: [],
  practicasSeleccionadas: [],
  gruposSeleccionados: [],
  documentacion: [],
  solicitudes: [],
};

export const laboratorioReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.laboratorioClear:
      return {
        ...state,
        // buscadorPracticas: [],
        practicas: [],
        practicasSeleccionadas: [],
        gruposSeleccionados: [],
        documentacion: [],
        solicitudes: [],
        solicitudesAutorizadas: [],
      };
    // case types.laboratorioResetBuscadorPracticas:
    //   return {
    //     ...state,
    //     buscadorPracticas: [],
    //   };
    // case types.laboratorioGetBuscadorPracticasSuccess:
    //   return {
    //     ...state,
    //     buscadorPracticas: action.payload,
    //   };
    // case types.laboratorioGetBuscadorPracticasError:
    //   return {
    //     ...state,
    //     buscadorPracticas: action.payload,
    //   };
    case types.laboratorioGetPracticasSuccess:
      return {
        ...state,
        practicas: action.payload,
      };
    case types.laboratorioGetPracticasError:
      return {
        ...state,
        practicas: [],
      };
    case types.laboratorioCleanPracticas:
      return {
        ...state,
        practicas: [],
      };
    case types.laboratorioAddPractica:
      return {
        ...state,
        practicas: action.payload,
      };
    case types.laboratorioSetPracticasSeleccionadas:
      return {
        ...state,
        practicasSeleccionadas: action.payload,
      };
    case types.laboratorioCleanPracticasSeleccionadas:
      return {
        ...state,
        practicasSeleccionadas: [],
      };
    case types.laboratorioSetGruposSeleccionados:
      return {
        ...state,
        gruposSeleccionados: action.payload,
      };
    case types.laboratorioCleanGruposSeleccionados:
      return {
        ...state,
        gruposSeleccionados: [],
      };
    case types.laboratorioSetDocumentacion:
      return {
        ...state,
        documentacion: action.payload,
      };
    case types.laboratorioDeleteDocumentacion:
      return {
        ...state,
        documentacion: state.documentacion.filter((item) => item.idDocumento !== action.payload),
      };
    case types.laboratorioCleanDocumentacion:
      return {
        ...state,
        documentacion: [],
      };
    case types.laboratorioSetSolicitudes:
      return {
        ...state,
        solicitudes: action.payload,
      };
    case types.laboratorioSetSolicitudesAutorizadas:
      return {
        ...state,
        solicitudesAutorizadas: action.payload,
      };
    default:
      return state;
  }
};
